import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import styles from './KgInsightSkeleton.module.scss';

export const KgInsightSkeleton = () => {
  const LOADING_SKELETON_AREAS = [
    { styles: { width: '100%', height: '64px', borderRadius: '8px' } },
    { styles: { width: '100%', height: '136px', borderRadius: '8px' } },
    { styles: { width: '100%', height: '400px', borderRadius: '8px' } },
    { styles: { width: '100%', height: '400px', borderRadius: '8px' } },
  ];

  return (
    <SkeletonLoader
      className={styles.loadingSkeletonWrapper}
      areas={LOADING_SKELETON_AREAS}
    />
  );
};
